import { Article } from '@core/models/article.models';
import { GgPaginatedState } from '@core/models/paginated-data.models';

export interface ArticlesState extends GgPaginatedState<Article> {
  selected: string[];
  isLoaded: boolean;
  isLoading: boolean;
}
